enum TransactionType {
    //adhocFee = 'AD_HOC_FEE',
    //scheduledFee = 'SCHEDULED_FEE',
    eurosicInboundPayment = 'EUROSIC_INBOUND_PAYMENT',
    eurosicOutboundPayment = 'EUROSIC_OUTBOUND_PAYMENT',
    sicInboundPayment = 'SIC_INBOUND_PAYMENT',
    sicOutboundPayment = 'SIC_OUTBOUND_PAYMENT',
    sicSettlement = 'SIC_SETTLEMENT',
    fpsInboundPayment = 'FPS_INBOUND_PAYMENT',
    fpsOutboundPayment = 'FPS_OUTBOUND_PAYMENT',
    chapsInboundPayment = 'CHAPS_INBOUND_PAYMENT',
    chapsOutboundPayment = 'CHAPS_OUTBOUND_PAYMENT',
    swiftInboundPayment = 'SWIFT_INBOUND_PAYMENT',
    swiftOutboundPayment = 'SWIFT_OUTBOUND_PAYMENT',
    bacsInboundPayment = 'BACS_INBOUND_PAYMENT',
    bacsOutboundPayment = 'BACS_OUTBOUND_PAYMENT',
    sepaInboundPayment = 'SEPA_INBOUND_PAYMENT',
    sepaOutboundPayment = 'SEPA_OUTBOUND_PAYMENT',
    //interest = 'INTEREST',
    chargeback = 'CHARGEBACK',
    domesticAtm = 'DOMESTIC_ATM',
    domesticAtmFx = 'DOMESTIC_ATM_FX',
    euroAtm = 'EURO_ATM',
    internationalAtm = 'INTERNATIONAL_ATM',
    domesticPos = 'DOMESTIC_POS',
    domesticPosFx = 'DOMESTIC_POS_FX',
    euroPos = 'EURO_POS',
    internationalPos = 'INTERNATIONAL_POS',
    domesticEcom = 'DOMESTIC_ECOM',
    domesticEcomFx = 'DOMESTIC_ECOM_FX',
    euroEcom = 'EURO_ECOM',
    internationalEcom = 'INTERNATIONAL_ECOM',
    //transferIncomingPayment = 'TRANSFER_INCOMING_PAYMENT',
    reward = 'REWARD',
    domesticMoto= 'DOMESTIC_MOTO',
    domesticMotoFx = 'DOMESTIC_MOTO_FX',
    euroMoto = 'EURO_MOTO',
    internationalMoto = 'INTERNATIONAL_MOTO',
    walletTransfer = "WALLET_TRANSFER",
    cardSchemeInterchangeFee = "CARD_SCHEME_INTERCHANGE_FEE"
}
export default TransactionType